export function imprimirEtiquetasDec(configuracionLanding) {
  const etiquetasDeclarativas = configuracionLanding.etiquetas.declarativa
  const formularios = document.querySelectorAll('.wg-form')
  // campaña se declara en cada landing configuracion.json
  etiquetasDeclarativas.campaña = "campaña" in etiquetasDeclarativas ? insertCampaing() : "";
  // refactor : indica que todas las urls cargan satellite_landings
  etiquetasDeclarativas.refactor= "si"
  console.log(etiquetasDeclarativas)

  for (const [etqName, etqValor] of Object.entries(etiquetasDeclarativas)) {
    console.log(`${etqName} ${etqValor}`)
    if (window.userLabels.EDeclaratives) window.userLabels.EDeclaratives[etqName] = etqValor
    const hiddenDec = `<input type="hidden" name="${etqName}" id="${etqName}" value="${etqValor}" >`
    formularios.forEach((form) => {
      form.innerHTML += hiddenDec
    })
  }
}

function insertCampaing() {
  let urlData = new URL(window.location.href);
  let valorCampaing = urlData.searchParams.get("utm_campaign");

  if(valorCampaing != null && valorCampaing != undefined && valorCampaing != "undefined"){        
    return valorCampaing
  }
  return;
}
